import type { HTMLAttributes } from "react";

import { cn, cv, type VariantProps } from "../utils";

const ncFormattedMessageVariants = cv(
  cn(
    "font-normal leading-[1.3] max-w-160 [&_strong]:font-bold [&_em]:italic",
    "[&_p+*]:mt-2.5 [&_p]:whitespace-pre-wrap",
    "[&_ul+*]:mt-2.5 [&_ol+*]:mt-2.5 [&_ul]:ml-6 [&_ol]:ml-6 [&_ul]:list-disc [&_ol]:list-decimal [&_ol_li]:pl-0.5",
    "[&_a]:underline [&_a]:focus-visible:outline-main [&_a]:focus-visible:outline-2 [&_a]:focus-visible:outline-offset-2"
  ),
  {
    variants: {
      variant: {
        default: "",
        danger: "text-danger-active",
        secondary: "italic",
        small: "text-[0.9rem]",
      },
    },
  }
);

type NcFormattedMessageProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof ncFormattedMessageVariants>;

export const NcFormattedMessage = ({
  variant = "default",
  className,
  ...props
}: NcFormattedMessageProps) => {
  return (
    <div
      data-nc="NcFormattedMessage"
      className={cn(ncFormattedMessageVariants({ variant }), className)}
      {...props}
    />
  );
};
